module.exports = __webpack_public_path__ + "img/star-icon.c51b4d35.svg";